// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  position: sticky;
  top: 0;
  flex-shrink: 0;
  height: 64px;
  width: 100%;
  background: #1a1a1a;
  border-bottom: 1px solid #1f2937;
  z-index: 999;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 24px;
}

.header-left {
  flex: 1 1;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notifications {
  position: relative;
}

.notification-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-btn:hover {
  background: #374151;
  color: #ffffff;
}

.bell-icon {
  display: block;
}

.notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #A61B34;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  animation: pulse 2s infinite;
}

.downloads-badge-wrap {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #e5e7eb;
}

.downloads-badge-label {
  position: relative;
  display: inline-flex;
}

.downloads-badge-wrap .download-badge {
  background: #2563eb;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.user-info-container {
  position: relative;
  isolation: isolate;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background-color 0.2s;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  appearance: none;
  color: inherit;
  width: auto;
  text-align: left;
  font-family: inherit;
}

.user-info:hover {
  background: rgba(255, 255, 255, 0.05);
}

.user-info:focus {
  outline: none;
  box-shadow: none;
}

.user-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  border: none;
  flex-shrink: 0;
  box-shadow: none;
  overflow: hidden;
}

.user-avatar-initials {
  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  border: none;
  border-width: 0;
  box-shadow: none;
  margin-top: -12px;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
  border: none;
  border-width: 0;
  padding: 0;
  text-decoration: none;
  box-shadow: none;
}

.user-name::before,
.user-name::after {
  display: none !important;
}

.user-role-badge {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(127, 29, 29, 0.4);
  color: #f87171;
  border: 1px solid rgba(185, 28, 28, 0.5);
  font-weight: 500;
}

.dropdown-arrow {
  font-size: 10px;
  color: #9ca3af;
  transition: transform 0.2s;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: #1a1a1a;
  border: 1px solid #1f2937;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  padding: 6px 0;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  background: transparent;
  border: none;
  color: #e5e7eb;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.dropdown-item-logout {
  color: #ef4444;
}

.dropdown-item-logout:hover {
  background: rgba(239, 68, 68, 0.1);
}

/* Panel campana: misma base que .user-dropdown (#1a1a1a / #1f2937) */
.header-notifications-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: min(480px, calc(100vw - 48px));
  max-height: min(420px, 70vh);
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  border: 1px solid #1f2937;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  overflow: hidden;
  font-family: inherit;
}

.header-notifications-dropdown__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #1f2937;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.header-notifications-dropdown__loading {
  color: #9ca3af;
  font-weight: 400;
}

.header-notifications-dropdown__list {
  overflow-y: auto;
  max-height: min(360px, 55vh);
  padding: 6px 0;
}

.header-notifications-dropdown__list::-webkit-scrollbar {
  width: 6px;
}

.header-notifications-dropdown__list::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 3px;
}

.header-notifications-dropdown__list::-webkit-scrollbar-track {
  background: transparent;
}

.header-notifications-dropdown__empty {
  margin: 0;
  padding: 20px 16px;
  font-size: 14px;
  color: #9ca3af;
  text-align: center;
}

.header-notifications-dropdown__item {
  margin: 0 8px 8px;
  border-radius: 8px;
  border: 1px solid #2a2a2a;
  background: #1a1a1a;
  transition: background-color 0.15s, border-color 0.15s;
}

.header-notifications-dropdown__item:hover {
  background: rgba(55, 65, 81, 0.35);
  border-color: rgba(255, 255, 255, 0.1);
}

.header-notifications-dropdown__item:last-child {
  margin-bottom: 10px;
}

/* Icono + contenido; acciones en fila inferior */
.header-notifications-dropdown__item-grid {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px 14px;
  align-items: start;
  padding: 12px 14px 10px;
}

.header-notifications-dropdown__item-icon-wrap {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(166, 27, 52, 0.22);
  color: #fca5a5;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.header-notifications-dropdown__item-icon-wrap--play {
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  transition:
    background 0.15s,
    color 0.15s,
    opacity 0.15s;
}

button.header-notifications-dropdown__item-icon-wrap--play:hover:not(:disabled) {
  background: rgba(166, 27, 52, 0.4);
  color: #fecaca;
}

button.header-notifications-dropdown__item-icon-wrap--play:focus-visible {
  outline: 2px solid rgba(166, 27, 52, 0.55);
  outline-offset: 2px;
}

button.header-notifications-dropdown__item-icon-wrap--play:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.header-notifications-dropdown__item-content {
  min-width: 0;
}

.header-notifications-dropdown__item-headline {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-notifications-dropdown__item-title-eu {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #f8fafc;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.header-notifications-dropdown__item-when {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

.header-notifications-dropdown__item-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.header-notifications-dropdown__item-block:last-of-type {
  margin-bottom: 0;
}

.header-notifications-dropdown__prov-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.header-notifications-dropdown__item-site-name {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  line-height: 1.35;
}

.header-notifications-dropdown__item-address {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.45;
}

.map-alert-press-count {
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.header-notifications-dropdown__item-alarm-type {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #fecaca;
  line-height: 1.4;
}

.header-notifications-dropdown__item-actions-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px 14px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.header-notifications-dropdown__item-actions-row .header-notifications-dropdown__action {
  flex: 1 1;
  justify-content: center;
  padding: 8px 12px;
  font-size: 12px;
}

/* Botones alineados con map-alert-toast__action-btn */
.header-notifications-dropdown__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #2a2a2a;
  background: #111111;
  color: #e5e7eb;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  font-family: inherit;
}

.header-notifications-dropdown__action:hover:not(:disabled) {
  background: #374151;
  border-color: #4b5563;
  color: #fff;
}

.header-notifications-dropdown__action:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.header-notifications-dropdown__action--primary {
  background: #A61B34;
  border-color: rgba(166, 27, 52, 0.85);
  color: #ffffff;
}

.header-notifications-dropdown__action--primary:hover:not(:disabled) {
  background: #8b1530;
  border-color: #A61B34;
  color: #fff;
}

@media (max-width: 520px) {
  .header-notifications-dropdown__item-headline {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .header-notifications-dropdown__item-actions-row {
    flex-direction: column;
  }
}

/* Modal confirmar gestión (portal) */
.header-alerts-manage-modal__backdrop {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  backdrop-filter: blur(2px);
}

.header-alerts-manage-modal {
  width: 100%;
  max-width: 440px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  background: #1a1a1a;
  border: 1px solid #2a2a2a;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  font-family: inherit;
}

.header-alerts-manage-modal__header {
  padding: 20px 20px 12px;
  border-bottom: 1px solid #2a2a2a;
}

.header-alerts-manage-modal__header-icon {
  color: #A61B34;
  margin-bottom: 10px;
}

.header-alerts-manage-modal__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: #f8fafc;
}

.header-alerts-manage-modal__subtitle {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.45;
}

.header-alerts-manage-modal__context {
  padding: 14px 20px;
  background: #111111;
  border-bottom: 1px solid #2a2a2a;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-alerts-manage-modal__context-headline {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 4px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-alerts-manage-modal__context-kind {
  font-size: 15px;
  font-weight: 700;
  color: #f8fafc;
  line-height: 1.25;
}

.header-alerts-manage-modal__context-when {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
}

.header-alerts-manage-modal__context-sublabel {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  margin-top: 10px;
}

.header-alerts-manage-modal__context-value {
  font-size: 13px;
  font-weight: 600;
  color: #e2e8f0;
  line-height: 1.4;
  margin-top: 2px;
}

.header-alerts-manage-modal__context-alarm {
  font-size: 13px;
  font-weight: 600;
  color: #fecaca;
  line-height: 1.4;
  margin-top: 2px;
}

.header-alerts-manage-modal__context-msg {
  font-size: 12px;
  color: #cbd5e1;
  line-height: 1.45;
  margin-top: 2px;
}

.header-alerts-manage-modal__field {
  padding: 16px 20px 0;
}

.header-alerts-manage-modal__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #e2e8f0;
  margin-bottom: 8px;
}

.header-alerts-manage-modal__hint {
  font-weight: 400;
  color: #94a3b8;
}

.header-alerts-manage-modal__captcha-row {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.header-alerts-manage-modal__captcha-char {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 40px;
  font-family: ui-monospace, 'Cascadia Code', 'Segoe UI Mono', monospace;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #0f172a;
  background: linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%);
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  -webkit-user-select: none;
          user-select: none;
}

.header-alerts-manage-modal__input,
.header-alerts-manage-modal__textarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #2a2a2a;
  background: #0a0a0a;
  color: #f1f5f9;
  font-size: 14px;
  font-family: inherit;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.header-alerts-manage-modal__input:focus,
.header-alerts-manage-modal__textarea:focus {
  border-color: rgba(166, 27, 52, 0.55);
  box-shadow: 0 0 0 2px rgba(166, 27, 52, 0.2);
}

.header-alerts-manage-modal__textarea {
  resize: vertical;
  min-height: 88px;
  line-height: 1.45;
}

.header-alerts-manage-modal__error {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #fca5a5;
}

.header-alerts-manage-modal__counter {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
}

.header-alerts-manage-modal__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px;
  margin-top: 8px;
  border-top: 1px solid #2a2a2a;
}

.header-alerts-manage-modal__btn {
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: none;
  transition: background 0.15s, opacity 0.15s;
}

.header-alerts-manage-modal__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.header-alerts-manage-modal__btn--ghost {
  background: transparent;
  color: #94a3b8;
  border: 1px solid #2a2a2a;
}

.header-alerts-manage-modal__btn--ghost:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.06);
  color: #e2e8f0;
}

.header-alerts-manage-modal__btn--primary {
  background: #A61B34;
  color: #fff;
}

.header-alerts-manage-modal__btn--primary:hover:not(:disabled) {
  background: #8b1530;
}

.bell-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAGhB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;EACf;;;iBAGe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sEAAsE;EACtE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kDAAkD;EAClD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,gDAAgD;AAClD;;AAEA;;EAEE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".app-header {\n  position: sticky;\n  top: 0;\n  flex-shrink: 0;\n  height: 64px;\n  width: 100%;\n  background: #1a1a1a;\n  border-bottom: 1px solid #1f2937;\n  z-index: 999;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  padding: 0 24px;\n}\n\n.header-left {\n  flex: 1;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.notifications {\n  position: relative;\n}\n\n.notification-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.2s;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-btn:hover {\n  background: #374151;\n  color: #ffffff;\n}\n\n.bell-icon {\n  display: block;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: #A61B34;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  animation: pulse 2s infinite;\n}\n\n.downloads-badge-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  color: #e5e7eb;\n}\n\n.downloads-badge-label {\n  position: relative;\n  display: inline-flex;\n}\n\n.downloads-badge-wrap .download-badge {\n  background: #2563eb;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n.user-info-container {\n  position: relative;\n  isolation: isolate;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 6px;\n  transition: background-color 0.2s;\n  background: transparent;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  color: inherit;\n  width: auto;\n  text-align: left;\n  font-family: inherit;\n}\n\n.user-info:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.user-info:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  border: none;\n  flex-shrink: 0;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.user-avatar-initials {\n  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-start;\n  border: none;\n  border-width: 0;\n  box-shadow: none;\n  margin-top: -12px;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n  border: none;\n  border-width: 0;\n  padding: 0;\n  text-decoration: none;\n  box-shadow: none;\n}\n\n.user-name::before,\n.user-name::after {\n  display: none !important;\n}\n\n.user-role-badge {\n  display: inline-block;\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: rgba(127, 29, 29, 0.4);\n  color: #f87171;\n  border: 1px solid rgba(185, 28, 28, 0.5);\n  font-weight: 500;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  color: #9ca3af;\n  transition: transform 0.2s;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(180deg);\n}\n\n.user-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 200px;\n  background: #1a1a1a;\n  border: 1px solid #1f2937;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\n  padding: 6px 0;\n  z-index: 1000;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 16px;\n  background: transparent;\n  border: none;\n  color: #e5e7eb;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-align: left;\n}\n\n.dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dropdown-item-logout {\n  color: #ef4444;\n}\n\n.dropdown-item-logout:hover {\n  background: rgba(239, 68, 68, 0.1);\n}\n\n/* Panel campana: misma base que .user-dropdown (#1a1a1a / #1f2937) */\n.header-notifications-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: min(480px, calc(100vw - 48px));\n  max-height: min(420px, 70vh);\n  display: flex;\n  flex-direction: column;\n  background: #1a1a1a;\n  border: 1px solid #1f2937;\n  border-radius: 8px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  overflow: hidden;\n  font-family: inherit;\n}\n\n.header-notifications-dropdown__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.header-notifications-dropdown__loading {\n  color: #9ca3af;\n  font-weight: 400;\n}\n\n.header-notifications-dropdown__list {\n  overflow-y: auto;\n  max-height: min(360px, 55vh);\n  padding: 6px 0;\n}\n\n.header-notifications-dropdown__list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.header-notifications-dropdown__list::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 3px;\n}\n\n.header-notifications-dropdown__list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.header-notifications-dropdown__empty {\n  margin: 0;\n  padding: 20px 16px;\n  font-size: 14px;\n  color: #9ca3af;\n  text-align: center;\n}\n\n.header-notifications-dropdown__item {\n  margin: 0 8px 8px;\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n  background: #1a1a1a;\n  transition: background-color 0.15s, border-color 0.15s;\n}\n\n.header-notifications-dropdown__item:hover {\n  background: rgba(55, 65, 81, 0.35);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.header-notifications-dropdown__item:last-child {\n  margin-bottom: 10px;\n}\n\n/* Icono + contenido; acciones en fila inferior */\n.header-notifications-dropdown__item-grid {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px 14px;\n  align-items: start;\n  padding: 12px 14px 10px;\n}\n\n.header-notifications-dropdown__item-icon-wrap {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: rgba(166, 27, 52, 0.22);\n  color: #fca5a5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.header-notifications-dropdown__item-icon-wrap--play {\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    color 0.15s,\n    opacity 0.15s;\n}\n\nbutton.header-notifications-dropdown__item-icon-wrap--play:hover:not(:disabled) {\n  background: rgba(166, 27, 52, 0.4);\n  color: #fecaca;\n}\n\nbutton.header-notifications-dropdown__item-icon-wrap--play:focus-visible {\n  outline: 2px solid rgba(166, 27, 52, 0.55);\n  outline-offset: 2px;\n}\n\nbutton.header-notifications-dropdown__item-icon-wrap--play:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.header-notifications-dropdown__item-content {\n  min-width: 0;\n}\n\n.header-notifications-dropdown__item-headline {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.header-notifications-dropdown__item-title-eu {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #f8fafc;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n}\n\n.header-notifications-dropdown__item-when {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.header-notifications-dropdown__item-block {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n}\n\n.header-notifications-dropdown__item-block:last-of-type {\n  margin-bottom: 0;\n}\n\n.header-notifications-dropdown__prov-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.header-notifications-dropdown__item-site-name {\n  margin: 0 0 2px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e2e8f0;\n  line-height: 1.35;\n}\n\n.header-notifications-dropdown__item-address {\n  margin: 0;\n  font-size: 12px;\n  color: #94a3b8;\n  line-height: 1.45;\n}\n\n.map-alert-press-count {\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.header-notifications-dropdown__item-alarm-type {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fecaca;\n  line-height: 1.4;\n}\n\n.header-notifications-dropdown__item-actions-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.header-notifications-dropdown__item-actions-row .header-notifications-dropdown__action {\n  flex: 1;\n  justify-content: center;\n  padding: 8px 12px;\n  font-size: 12px;\n}\n\n/* Botones alineados con map-alert-toast__action-btn */\n.header-notifications-dropdown__action {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #2a2a2a;\n  background: #111111;\n  color: #e5e7eb;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  font-family: inherit;\n}\n\n.header-notifications-dropdown__action:hover:not(:disabled) {\n  background: #374151;\n  border-color: #4b5563;\n  color: #fff;\n}\n\n.header-notifications-dropdown__action:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.header-notifications-dropdown__action--primary {\n  background: #A61B34;\n  border-color: rgba(166, 27, 52, 0.85);\n  color: #ffffff;\n}\n\n.header-notifications-dropdown__action--primary:hover:not(:disabled) {\n  background: #8b1530;\n  border-color: #A61B34;\n  color: #fff;\n}\n\n@media (max-width: 520px) {\n  .header-notifications-dropdown__item-headline {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .header-notifications-dropdown__item-actions-row {\n    flex-direction: column;\n  }\n}\n\n/* Modal confirmar gestión (portal) */\n.header-alerts-manage-modal__backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  backdrop-filter: blur(2px);\n}\n\n.header-alerts-manage-modal {\n  width: 100%;\n  max-width: 440px;\n  max-height: calc(100vh - 48px);\n  overflow-y: auto;\n  background: #1a1a1a;\n  border: 1px solid #2a2a2a;\n  border-radius: 12px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  font-family: inherit;\n}\n\n.header-alerts-manage-modal__header {\n  padding: 20px 20px 12px;\n  border-bottom: 1px solid #2a2a2a;\n}\n\n.header-alerts-manage-modal__header-icon {\n  color: #A61B34;\n  margin-bottom: 10px;\n}\n\n.header-alerts-manage-modal__title {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #f8fafc;\n}\n\n.header-alerts-manage-modal__subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: #94a3b8;\n  line-height: 1.45;\n}\n\n.header-alerts-manage-modal__context {\n  padding: 14px 20px;\n  background: #111111;\n  border-bottom: 1px solid #2a2a2a;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.header-alerts-manage-modal__context-headline {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 4px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.header-alerts-manage-modal__context-kind {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f8fafc;\n  line-height: 1.25;\n}\n\n.header-alerts-manage-modal__context-when {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.header-alerts-manage-modal__context-sublabel {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-top: 10px;\n}\n\n.header-alerts-manage-modal__context-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #e2e8f0;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.header-alerts-manage-modal__context-alarm {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fecaca;\n  line-height: 1.4;\n  margin-top: 2px;\n}\n\n.header-alerts-manage-modal__context-msg {\n  font-size: 12px;\n  color: #cbd5e1;\n  line-height: 1.45;\n  margin-top: 2px;\n}\n\n.header-alerts-manage-modal__field {\n  padding: 16px 20px 0;\n}\n\n.header-alerts-manage-modal__label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #e2e8f0;\n  margin-bottom: 8px;\n}\n\n.header-alerts-manage-modal__hint {\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.header-alerts-manage-modal__captcha-row {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.header-alerts-manage-modal__captcha-char {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 40px;\n  font-family: ui-monospace, 'Cascadia Code', 'Segoe UI Mono', monospace;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #0f172a;\n  background: linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%);\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n  user-select: none;\n}\n\n.header-alerts-manage-modal__input,\n.header-alerts-manage-modal__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n  background: #0a0a0a;\n  color: #f1f5f9;\n  font-size: 14px;\n  font-family: inherit;\n  padding: 10px 12px;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.header-alerts-manage-modal__input:focus,\n.header-alerts-manage-modal__textarea:focus {\n  border-color: rgba(166, 27, 52, 0.55);\n  box-shadow: 0 0 0 2px rgba(166, 27, 52, 0.2);\n}\n\n.header-alerts-manage-modal__textarea {\n  resize: vertical;\n  min-height: 88px;\n  line-height: 1.45;\n}\n\n.header-alerts-manage-modal__error {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #fca5a5;\n}\n\n.header-alerts-manage-modal__counter {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #64748b;\n}\n\n.header-alerts-manage-modal__actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 20px;\n  margin-top: 8px;\n  border-top: 1px solid #2a2a2a;\n}\n\n.header-alerts-manage-modal__btn {\n  padding: 10px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  transition: background 0.15s, opacity 0.15s;\n}\n\n.header-alerts-manage-modal__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.header-alerts-manage-modal__btn--ghost {\n  background: transparent;\n  color: #94a3b8;\n  border: 1px solid #2a2a2a;\n}\n\n.header-alerts-manage-modal__btn--ghost:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.06);\n  color: #e2e8f0;\n}\n\n.header-alerts-manage-modal__btn--primary {\n  background: #A61B34;\n  color: #fff;\n}\n\n.header-alerts-manage-modal__btn--primary:hover:not(:disabled) {\n  background: #8b1530;\n}\n\n.bell-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
